import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./EventAvMode.scss";
import { Locale } from '../../../../assets/Locale';
import { sayEventAvMode } from '../../eventSay';

export const EventAvMode = (props)=>{
    const { value } = props;
    const say = Locale.use();

    return (
        <Block className="EventAvMode">
            {value?.map?.(mode=>(
                <div key={mode} className="avChip" data-value={mode}>
                    {sayEventAvMode(say, mode)}
                </div>
            ))}
        </Block>
    );
};

